enum CliActions {
  dev = 'dev',
  build = 'build',
  buildDocker = 'build-docker',
  buildAmplify = 'build-amplify',
  buildVercel = 'build-vercel',
  start = 'start',
  preview = 'preview',
}

export default CliActions;
